'use strict';exports.__esModule = true;exports.hideUpgradePackageModal = exports.openUpgradePackageModal = exports.resetData = exports.changeSelectedPackage = undefined;var _reduxAct = require('redux-act');
var _packagesData = require('../../packagesData');

var resetData = (0, _reduxAct.createAction)('/RESET_DATA');
var changeSelectedPackage = (0, _reduxAct.createAction)('/SELECT_PACKAGE');
var openUpgradePackageModal = (0, _reduxAct.createAction)('/OPEN_UPGRADE_REGULAR_USER_PACKAGE_MODAL');
var hideUpgradePackageModal = (0, _reduxAct.createAction)('/HIDE_UPGRADE_REGULAR_USER_PACKAGE_MODAL');

var initialState = {
  sending: false,
  sent: false,
  error: null,
  currentPropertyId: null,
  selectedPackage: (0, _packagesData.getDefaultSelectedPackageForUpdate)(),
  upgradeRegularPackageIsOpen: false };


var handleResetData = function handleResetData(state) {return Object.assign({},
  state,
  initialState);};


var handleSelectPackage = function handleSelectPackage(state, change) {return Object.assign({},
  state, {
    selectedPackage: Object.assign({},
    state.selectedPackage,
    change) });};



var handleOpenUpgradePackageModal = function handleOpenUpgradePackageModal(state, propertyId) {return Object.assign({},
  state, {
    currentPropertyId: propertyId,
    selectedPackage: initialState.selectedPackage,
    upgradeRegularPackageIsOpen: true });};


var handleHideUpgradePackageModal = function handleHideUpgradePackageModal(state) {return Object.assign({},
  state, {
    upgradeRegularPackageIsOpen: false });};


var upgradeRegularUserPackage = (0, _reduxAct.createReducer)(function (on) {
  on(resetData, handleResetData);
  on(changeSelectedPackage, handleSelectPackage);
  on(openUpgradePackageModal, handleOpenUpgradePackageModal);
  on(hideUpgradePackageModal, handleHideUpgradePackageModal);
}, initialState);exports.


changeSelectedPackage = changeSelectedPackage;exports.
resetData = resetData;exports.
openUpgradePackageModal = openUpgradePackageModal;exports.
hideUpgradePackageModal = hideUpgradePackageModal;exports.default =


upgradeRegularUserPackage;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/upgradeRegularUserPackage.js
// module id = 399
// module chunks = 0